import React from 'react';
import {Link} from 'react-router-dom';
import I18n from 'app/i18n';
import {getLinkPath} from 'app/utils';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import ParticipatePromoButton from 'app/components/reusable/ParticipatePromoButton';
import AnimatedParticipantsCount from './AnimatedParticipantsCount';

interface PromoNewCardFooterActionsProps {
    isPermanent: boolean
    slug: string
    canParticipate: boolean
    isParticipating: boolean
    participantsCount: number
    promoId: number
    cardTitle: string
    awardMode?: string
    onPromotionClick: () => void
}

const PromoNewCardFooterActions = ({
    isPermanent,
    slug,
    canParticipate,
    isParticipating,
    participantsCount,
    promoId,
    cardTitle,
    awardMode,
    onPromotionClick
}: PromoNewCardFooterActionsProps): React.ReactElement => {
    if (isPermanent) {
        return <Link
            to={getLinkPath(`/promotions/${slug}`)}
            className="promo-new-card__btn promo-new-card__btn--ghost"
            onClick={onPromotionClick}
        >
            {I18n.t('promo_new_details')}
        </Link>;
    }

    return <>
        {canParticipate &&
            <div className="promo-new-card__participants">
                <SpriteIcon name="#svg-account" size={{height: 16, width: 16}} />
                <AnimatedParticipantsCount value={participantsCount} />
            </div>
        }
        {awardMode === 'at_promo_end' &&
            <span className="promo-new-card__award-note">
                {I18n.t('bonuses_page.awarded_at_period_end')}
            </span>
        }
        {isParticipating &&
            <div className="promo-new-card__participating-status">
                <SpriteIcon
                    name="#svg-check"
                    size={{height: 11, width: 11}}
                />
                <span>{I18n.t('bonuses_page.you_are_participating')}</span>
            </div>
        }
        {!isParticipating && canParticipate &&
            <ParticipatePromoButton
                isParticipating={false}
                promoId={promoId}
                title={cardTitle}
                authPlacement="PROMO_NEW_CARD"
                className="promo-new-card__btn"
            />
        }
    </>;
};

export default PromoNewCardFooterActions;
